// @ts-nocheck

import {
  getContent, contentType,
} from '@/modules/content/ContentService';
import { contentVariables } from '@/constants';

export const ContentMixin = function (contents: contentType[]) {
  return {
    data() {
      // Fallback values
      return {
        content: {
          announcement: contentVariables.ANNOUNCEMENT_FALLBACK,
          prelogin: contentVariables.PRELOGIN_FALLBACK,
          resources: contentVariables.RESOURCES_FALLBACK,
          features: contentVariables.FEATURES_FALLBACK,
          welcome: contentVariables.WELCOME_FALLBACK,
          coreFeatures: contentVariables.CORE_FEATURES_FALLBACK,
          pluginFeatures: contentVariables.PLUGIN_FEATURES_FALLBACK,
        },
        contentProviderURL: contentVariables.CONTENT_PROVIDER_URL,
      };
    },
    methods: {
      async fetchContent(type: contentType) {
        const contentResult = await getContent(type);

        if (contentResult.isOk()) {
          const content = contentResult.value.payload.data;
          this.content[type] = content;
        }
      },
      getFeatureContentByCode(code: string) {
        const feature = this.content.pluginFeatures.find((f) => f.attributes.featureID === code);

        if (feature) return feature.attributes;
        return false;
      },
    },
    async created() {
      // call fetchContent method for each content in contents array
      contents.forEach(async (content) => {
        await this.fetchContent(content);
      });
    },
  };
};
